// Homepage "testimonial" defaults (EN + FR): the founder quote (src/Sections/Testimonial).
// The headshot is built into that component until a photo is uploaded.
const TESTIMONIAL_DEFAULTS = {
  "en": {
    "eyebrow": "Our Commitment to Service",
    "quote": "My mission is to create opportunities for those who truly deserve them, when you hire the right people, excellence naturally follows.",
    "name": "Maximus Trinchini",
    "role": "Founder & President",
    "company": "Vision Sécurité Inc",
    "photoAlt": "Vision Sécurité Logo"
  },
  "fr": {
    "eyebrow": "Notre engagement envers le service",
    "quote": "Ma mission est de créer des opportunités pour celles et ceux qui les méritent vraiment; lorsque l’on recrute les bonnes personnes, l’excellence suit naturellement.",
    "name": "Maximus Trinchini",
    "role": "Fondateur et Président",
    "company": "Vision Sécurité Inc",
    "photoAlt": "Logo de Vision Sécurité"
  }
};

export default TESTIMONIAL_DEFAULTS;
